import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { HMemberService } from '@home/service/member.service';
import { SystemService } from '@admin/service/system.service';

import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-company-search',
  templateUrl: './company-search.component.html',
  styleUrls: ['./company-search.component.scss']
})
export class CompanySearchComponent implements OnInit {
  @Output() emitData = new EventEmitter();

  public search: any = {
    searchText: ''
  };


  public companyList = [];
  public companyIndex: any = -1;
  public maxMemberCouunt = 0;

  constructor(
    private toastrService: ToastrService,
    public activeModal: NgbActiveModal,
    public memberService: HMemberService,
    public systemService: SystemService,
  ) {

  }

  /*******************************************************************************
    설  명 : 초기화
  *******************************************************************************/
  ngOnInit() {
    // this.getSystemConfig();
  }

  /*******************************************************************************
    설  명 : 검색 input에서 엔터키 입력 시 검색 처리
    입력값 : $event
    리턴값 : 없음
  *******************************************************************************/
  searchList( event ) {
    if( event.key == 'Enter' ) {
      this.getCompanySearchList();
    }
  }

  /*******************************************************************************
    설  명 : 적용하기
  *******************************************************************************/
  submitSelectedCompany() {
    if( this.companyIndex == -1 ) {
      this.toastrService.warning( '적용할 기업을 선택하시기 바랍니다.', '');
      return false;
    }

    // // 기업별 담당자수 확인
    // if ( this.companyList[this.companyIndex].memberCount >= this.maxMemberCouunt ) {
    //   this.toastrService.warning( '해당 기업은 가입가능 회원 수를 초과 하였습니다. 주 담당자에게 문의 하십시오.');
    //   return false;
    // }

    this.emitData.next( this.companyList[this.companyIndex] );

    this.activeModal.close();
  }

  /*******************************************************************************
    설  명 : 회사검색 처리
  *******************************************************************************/
  getCompanySearchList() {
    if( this.search.searchText ) {
      this.companyList = [];
      this.memberService.getCompanySearchList( this.search ).then( response => {
        if( response.ResultCode ) {
          this.companyList = response.data;
        } else {
          this.toastrService.error( response.ResultMessage, '');
        }
      });
    } else {
      this.toastrService.error( '검색어를 입력하시기 바랍니다.', '');
    }
  }

  /*******************************************************************************
    설  명 : 시스템 설정 가져오기 (기업별 담당자수)
  *******************************************************************************/
  getSystemConfig() {
    this.systemService.getSystemConfig().then( response => {
      if ( response.ResultCode ) {
        for ( const item of response.data ) {
          if ( item.common_code === '3000' ) {
            this.maxMemberCouunt = item.c1;
          }
        }
      }
    }).catch( error => {
      this.toastrService.error(error, '시스템설정');
    });
  }
}
